<template>

</template>

<script>
export default {
  name: "HintsAndTipsPage"
}
</script>


